const initTarievenDialog = ( root ) => {
	const openBtn = root.querySelector( '.js-tarievenZonesOpen' );
	const dialog = root.querySelector( '.js-tarievenZonesDialog' );
	const closeBtn = root.querySelector( '.js-tarievenZonesClose' );

	if ( ! openBtn || ! dialog || typeof dialog.showModal !== 'function' ) {
		return;
	}

	const closeDialog = () => {
		if ( dialog.open ) {
			dialog.close();
		}
	};

	openBtn.addEventListener( 'click', () => {
		if ( ! dialog.open ) {
			dialog.showModal();
		}
	} );

	if ( closeBtn ) {
		closeBtn.addEventListener( 'click', closeDialog );
	}

	dialog.addEventListener( 'click', ( event ) => {
		if ( event.target === dialog ) {
			closeDialog();
		}
	} );

	dialog.addEventListener( 'cancel', ( event ) => {
		event.preventDefault();
		closeDialog();
	} );
};

document.querySelectorAll( '.sb-tarieven' ).forEach( ( root ) => {
	initTarievenDialog( root );
} );
